import { render, staticRenderFns } from "./sales-by-provider.vue?vue&type=template&id=e7114ac4&scoped=true&"
import script from "./sales-by-provider.vue?vue&type=script&lang=js&"
export * from "./sales-by-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7114ac4",
  null
  
)

export default component.exports